// Shared face geometry, in a 1000-unit frame centered on the cat's head.
export const EYES = [
  { x: -178, y: 27, tilt: -0.075, mirror: 1 },
  { x: 178, y: 27, tilt: 0.075, mirror: -1 },
];
export const IRIS = [
  { x: 0, y: 0, rx: 89, ry: 94, color: "#644a3d" },
  { x: 0, y: -3, rx: 83, ry: 88, color: "#322924" },
  { x: -2, y: -6, rx: 75, ry: 80, color: "#131313" },
  { x: -29, y: -35, rx: 18, ry: 19, color: "#ffffff" },
  { x: 22, y: -48, rx: 10, ry: 11, color: "#ffffff" },
  { x: 33, y: 42, rx: 9, ry: 10, color: "#fffef9" },
];
export const FACE_PATHS = {
  neutral: [
    {
      commands: [
        ["moveTo", 0, 155],
        ["lineTo", 0, 180],
        ["moveTo", -78, 188],
        ["quadraticCurveTo", -39, 221, 0, 180],
        ["quadraticCurveTo", 39, 221, 78, 188],
      ],
      stroke: "#755454",
      width: 12,
    },
  ],
  happy: [
    {
      commands: [
        ["moveTo", -75, 186],
        ["quadraticCurveTo", 0, 202, 75, 186],
        ["bezierCurveTo", 68, 284, -68, 284, -75, 186],
        ["closePath"],
      ],
      fill: "#633040",
    },
    {
      commands: [
        ["moveTo", -46, 197],
        ["quadraticCurveTo", 0, 207, 46, 197],
        ["lineTo", 39, 216],
        ["quadraticCurveTo", 0, 225, -39, 216],
        ["closePath"],
      ],
      fill: "#fffaf1",
    },
    {
      commands: [
        ["moveTo", -42, 252],
        ["quadraticCurveTo", 0, 227, 42, 252],
        ["quadraticCurveTo", 0, 278, -42, 252],
        ["closePath"],
      ],
      fill: "#f39aa9",
    },
  ],
  sad: [
    {
      commands: [
        ["moveTo", -66, 230],
        ["quadraticCurveTo", 0, 174, 66, 230],
      ],
      stroke: "#785252",
      width: 14,
    },
  ],
  eyelid: [
    {
      commands: [
        ["moveTo", -122, -113],
        ["lineTo", 122, -113],
        ["lineTo", 122, -76],
        ["quadraticCurveTo", 8, -105, -122, -20],
        ["closePath"],
      ],
      fill: "#2b282b",
    },
  ],
  closed: [
    {
      commands: [
        ["moveTo", -95, 0],
        ["quadraticCurveTo", 0, 37, 95, 0],
      ],
      stroke: "#c9bcb4",
      width: 9,
    },
  ],
  tear: [
    {
      commands: [
        ["moveTo", 0, 0],
        ["bezierCurveTo", -10, 16, -16, 23, -13, 34],
        ["bezierCurveTo", -8, 53, 14, 47, 14, 32],
        ["bezierCurveTo", 14, 22, 5, 9, 0, 0],
        ["closePath"],
      ],
      fill: "#a8dfee",
    },
  ],
};

export function tracePaths(target, commands) {
  for (const [method, ...args] of commands) target[method](...args);
}

export function paintCanvasPaths(context, paths) {
  for (const path of paths) {
    context.beginPath();
    tracePaths(context, path.commands);
    if (path.fill) {
      context.fillStyle = path.fill;
      context.fill();
    }
    if (path.stroke) {
      context.strokeStyle = path.stroke;
      context.lineWidth = path.width;
      context.lineCap = "round";
      context.lineJoin = "round";
      context.stroke();
    }
  }
}

export function paintCatPortrait(context, image, pose, size) {
  const scale = (size / 1000) * pose.reveal;
  context.setTransform(1, 0, 0, 1, 0, 0);
  context.clearRect(0, 0, size, size);
  context.save();
  context.translate(size / 2, size / 2 + pose.bob * scale);
  context.rotate(pose.angle);
  context.scale(scale * pose.xScale, scale * pose.yScale);
  context.drawImage(image, -500, -500, 1000, 1000);
  for (const eye of EYES) {
    context.save();
    context.translate(eye.x, eye.y);
    context.rotate(eye.tilt);
    context.save();
    context.scale(1, pose.eyeOpen);
    context.beginPath();
    context.ellipse(0, 0, 115, 108, 0, 0, Math.PI * 2);
    context.fillStyle = "#fffdf9";
    context.fill();
    context.save();
    context.translate(pose.gazeX * 22, pose.gazeY * 12);
    for (const layer of IRIS) {
      context.beginPath();
      context.ellipse(layer.x, layer.y, layer.rx, layer.ry, 0, 0, Math.PI * 2);
      context.fillStyle = layer.color;
      context.fill();
    }
    context.restore();
    context.restore();
    context.globalAlpha = pose.sad;
    context.save();
    context.scale(eye.mirror, 1);
    paintCanvasPaths(context, FACE_PATHS.eyelid);
    context.restore();
    context.globalAlpha = Math.max(0, (0.16 - pose.eyeOpen) / 0.16);
    paintCanvasPaths(context, FACE_PATHS.closed);
    context.restore();
  }
  context.globalAlpha = 1 - Math.max(pose.happy, pose.sad);
  paintCanvasPaths(context, FACE_PATHS.neutral);
  context.globalAlpha = pose.happy;
  paintCanvasPaths(context, FACE_PATHS.happy);
  context.globalAlpha = pose.sad;
  paintCanvasPaths(context, FACE_PATHS.sad);
  if (pose.sad > 0.01) {
    context.globalAlpha = pose.sad * 0.8;
    for (const side of [-1, 1]) {
      context.save();
      context.translate(side * 260, 92 + pose.tear * 60);
      paintCanvasPaths(context, FACE_PATHS.tear);
      context.restore();
    }
  }
  context.restore();
}
